import React, { ReactNode, useRef, useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import { clstagStr } from '../../utils/util';
import { CLSTAG } from '../../utils/constant';
type DraweProps = {
  defaultOpened: boolean;
  direction: 'left' | 'right' | 'bottom';
  width: number | string;
  height?: number | string; // 新增height属性，用于bottom方向
  collapsedHeight?: number | string; // 新增：收起时保留的高度
  autoOpenCollapse?: boolean;
  classNames?: string;
  btnWrapperCls?: string;
  children: ReactNode;
  collapseNode?: ReactNode; // 改为可选，当有collapsedHeight时可以不传
  handleCollapse?: (isOpened: boolean) => void;
  handleExpand?: (isOpened: boolean) => void;
};
const Drawer = (props: DraweProps) => {
  const {
    direction,
    width,
    height,
    collapsedHeight,
    classNames,
    collapseNode,
    autoOpenCollapse,
    defaultOpened,
    btnWrapperCls,
    handleCollapse,
    handleExpand,
  } = props;
  const suspendedRef = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  const [isOpened, setIsOpened] = useState(defaultOpened);

  const handleClickCollapseBtn = () => {
    if (autoOpenCollapse) {
      // 自动切换模式：根据当前状态切换
      if (isOpened) {
        // 当前是展开状态，执行收起
        if (direction === 'bottom') {
          const targetHeight = collapsedHeight
            ? typeof collapsedHeight === 'string'
              ? collapsedHeight
              : `${collapsedHeight}px`
            : '0px';
          drawerRef.current && (drawerRef.current!.style.height = targetHeight);
        } else {
          drawerRef.current && (drawerRef.current!.style.width = '0px');
          const collapseBtn: any = document.querySelector('.left-collapse-btn');
          if (collapseBtn) collapseBtn.style.right = '-24px';
        }
        setIsOpened(false);
        setTimeout(() => {
          handleCollapse && handleCollapse(false);
        }, 300);
      } else {
        // 当前是收起状态，执行展开
        if (direction === 'bottom') {
          drawerRef.current &&
            (drawerRef.current!.style.height =
              typeof height === 'string' ? height : `${height}px`);
        } else {
          drawerRef.current &&
            (drawerRef.current!.style.width =
              typeof width === 'string' ? width : `${width}px`);
          const collapseBtn: any = document.querySelector('.left-collapse-btn');
          if (collapseBtn) collapseBtn.style.right = '-8px';
        }
        setIsOpened(true);
        handleExpand && handleExpand(true);
      }
    } else {
      // 传统模式：只执行收起
      if (direction === 'bottom') {
        const targetHeight = collapsedHeight
          ? typeof collapsedHeight === 'string'
            ? collapsedHeight
            : `${collapsedHeight}px`
          : '0px';
        drawerRef.current && (drawerRef.current!.style.height = targetHeight);
      } else {
        drawerRef.current && (drawerRef.current!.style.width = '0px');
        const collapseBtn: any = document.querySelector('.left-collapse-btn');
        if (collapseBtn) collapseBtn.style.right = '-24px';
      }
      setIsOpened(false);
      setTimeout(() => {
        handleCollapse && handleCollapse(false);
      }, 300);
    }
  };

  const handleClickExpand = () => {
    if (direction === 'bottom') {
      drawerRef.current &&
        (drawerRef.current!.style.height =
          typeof height === 'string' ? height : `${height}px`);
    } else {
      drawerRef.current &&
        (drawerRef.current!.style.width =
          typeof width === 'string' ? width : `${width}px`);
    }
    setIsOpened(true);
    handleExpand && handleExpand(true);
  };

  const getDrawerStyle = () => {
    if (direction === 'bottom') {
      const expandedHeight = height || '300px';
      const collapsedHeightValue = collapsedHeight || 0;
      return {
        height: isOpened ? expandedHeight : collapsedHeightValue,
        width: width,
        bottom: isOpened ? expandedHeight : collapsedHeightValue,
        overflow: 'visible',
      };
    } else {
      return { width: isOpened ? width : 0 };
    }
  };

  return (
    <>
      <div
        ref={drawerRef}
        className={classnames('drawer-wrapper', `drawer-${direction}`, {
          [classNames || '']: true,
          'drawer-collapsed': !isOpened && collapsedHeight,
        })}
        style={getDrawerStyle()}
        // 当collapsedHeight > 0时，不使用点击区域展开，只通过按钮控制
      >
        {direction === 'left' && (
          <div
            className="left-collapse-btn"
            onClick={handleClickCollapseBtn}
            clstag={clstagStr(CLSTAG.LeftDrawerOpenClose)}
          >
            {autoOpenCollapse ? (
              // 自动切换模式：根据状态显示不同图标
              <img
                src={require('../../assets/img/views/common/collapse.png')}
                alt={isOpened ? 'collapse' : 'expand'}
                className={`collapse-icon ${isOpened ? 'opened' : 'closed'}`}
              />
            ) : (
              // 传统模式：只显示收起图标
              <img
                src={require('../../assets/img/views/common/collapse.png')}
                alt="collapse"
                className="collapse-icon"
              />
            )}
          </div>
        )}
        {direction === 'bottom' && (
          <div
            className="bottom-collapse-btn"
            onClick={(e) => {
              e.stopPropagation(); // 阻止事件冒泡
              // 当有collapsedHeight时，按钮控制展开收起切换
              if (collapsedHeight) {
                if (isOpened) {
                  handleClickCollapseBtn();
                } else {
                  handleClickExpand();
                }
              } else {
                // 没有collapsedHeight时，只能收起
                handleClickCollapseBtn();
              }
            }}
          >
            <img
              src={require('../../assets/img/views/common/collapse.png')}
              alt={isOpened ? 'collapse' : 'expand'}
              className={`collapse-icon ${collapsedHeight && !isOpened ? 'rotate-180' : ''}`}
            />
          </div>
        )}
        {props.children}
        {direction === 'right' && <i className="right-collapse-btn"></i>}
      </div>
      {/* 悬浮按钮：当没有collapsedHeight或者完全收起时显示，但autoOpenCollapse模式下不显示 */}
      {!autoOpenCollapse &&
        (!collapsedHeight || (!isOpened && !collapsedHeight)) &&
        collapseNode && (
          <div
            className={classnames('suspended-btn-area', {
              [btnWrapperCls || '']: true,
            })}
            ref={suspendedRef}
            onClick={handleClickExpand}
            style={{ display: isOpened ? 'none' : 'block' }}
          >
            {collapseNode}
            <div
              className="expand-icon"
              clstag={
                direction === 'left'
                  ? clstagStr(CLSTAG.LeftDrawerOpenClose)
                  : direction === 'bottom'
                    ? clstagStr(CLSTAG.WorkOrderDrawerOpenClose)
                    : clstagStr(CLSTAG.WorkOrderDrawerOpenClose)
              }
            >
              <i></i>
            </div>
          </div>
        )}
    </>
  );
};

export default React.memo(Drawer);
